// companySitesComplete   (no args)
// for the company_sites_manager input (FormulateCompanySitesManager) - its value is the list of what is still missing in the company's sites
// passes when that list is empty - the input lists the problems itself, so the message stays general
// the backend (CompanySitesInput) checks the sites again when the form saves
// NOTE: rule names must be camelCase (no underscores) - see js/formulate-config.js
const companySitesComplete = ({ value }) => Array.isArray(value) && value.length === 0;

const companySitesCompleteMessage = () => 'Your sites are not complete yet - see what is still needed above.';

export default {
  rules: { companySitesComplete },
  messages: {
    companySitesComplete: companySitesCompleteMessage,
  },
};
